import { PROPERTY_TYPES } from 'constants/Global';
import { isApartment } from 'helpers/FormInformations';
import { translate, translatePlural } from 'helpers/Translate';

/**
 * Function to format the floor number of an apartment
 * @param  {Object} estima - Object containing the estima values
 * @return {String} - Return the number of floors correctely formatted
 */
export const apartmentFloor = (estima) => {
    if (isApartment(estima)) {
        if (estima.floor === 0) {
            return translate('RDC');
        }

        return translatePlural('%ser étage', '%sème étage', estima.floor, [estima.floor]);
    }

    return '';
};

/**
 * Function to format the area of a property
 * @param  {Number} area - Area of the property
 * @return {String} - Return the area correctly formatted
 */
export const propertyArea = (area) => translate(`${Math.round(area)} m²`);

/**
 * Function to return the type of property
 * @param  {Object} estima - Object containing the estima values
 * @return {String} - Return the correct type of property
 */
export const propertyType = (type) =>
    PROPERTY_TYPES.filter((e) => e.id === type || e.type === type)[0].label;

/**
 * Function to return the number of rooms
 * @param  {Number} rooms - Number of rooms
 * @param  {Object} estima - Estima information
 * @return {String} - Return the number of rooms correctly formatted
 */
export const roomCount = (rooms, estima) => {
    if (isApartment(estima)) {
        return translatePlural('Studio', '%s pièces', rooms, [rooms]);
    }
    return translatePlural('%s pièce', '%s pièces', rooms, [rooms]);
};
